/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BdEntity {
    Department = 0,
}